import overflowTooltip from "./overflow-tooltip";

const directives = {
  overflowTooltip,
};

export default {
  install(Vue) {
    Object.keys(directives).forEach((name) => {
      Vue.directive(name, directives[name]);
    });
  },
};
